// import {
//     DIC
// } from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'


const validateName = (rule, value, callback) => {
    if (!validateChinese(value) || value.length > 30 || value.length < 1) {
        callback(new Error('名称为1-30位中文'))
    } else {
        callback();
    }
}

export const purchaseOrderOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    //viewBtn: true,
    menuWidth: '300',
    labelWidth: '150',
    defaultSort:{
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "进货单编号",
            prop: "supplyListNum",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },

        {
        label: "联系人",
        prop: "contactsName",
        search: true,
        type: 'input',
        rules: [{
            required: true,
            trigger: "blur",
            validator: validateName
        }]
    },
        {
            label: "联系人电话",
            prop: "contactsMobile",
            type: 'input',
            rules: [{
                trigger: "blur",
                required: true,
                message: "请输入电话"
            }]
        },
        {
            label: "配送方式",
            prop: "distributionMode",
            solt: true,
            formsolt: true,
            search: true
        },
        {
            label: "省",
            prop: "province",
            hide: true,
            formsolt: true
        },
        {
            label: "市",
            prop: "city",
            hide: true,
            formsolt: true
        },
        {
            label: "区",
            prop: "area",
            hide: true,
            formsolt: true
        }
        ,{

            label: "配送地址",
            prop: "address",
            hide: true,
            solt: true,
            formsolt: true
        },

        {
            label:"标记位置",
            prop:'provinces',
            hide: true,
            // span: 24,
            // solt: true,
            formsolt: true
        },
        {
            label: "供货商",
            prop: "supplierId",
            hide: true,
            solt: true,
            formsolt: true
        },
        {
            label: "商品清单",
            prop: "goodsList",
            span: 24,
            hide: true,
            solt: true,
            formsolt: true
        },
        {
            label: "进货单状态",
            prop: "status",
            type: "input",
            solt: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "发布时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },

        // {
        //     label: "创建人",
        //     prop: "createBy",
        //     type: "input",
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "状态",
        //     prop: "status",
        //     type: "radio",
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     dicData: DIC.STATE
        // },
        // {
        //     label: "更新时间",
        //     prop: "updateTime",
        //     type: "datetime",
        //     format: "yyyy-MM-dd HH:mm:ss",
        //     hide: true,
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "更新人",
        //     prop: "updateBy",
        //     type: "input",
        //     hide: true,
        //     addVisdiplay: false,
        //     editVisdiplay: false
        // },
        // {
        //     label: "是否删除",
        //     prop: "deleteFlag",
        //     type: "radio",
        //     hide: true,
        //     addVisdiplay: false,
        //     editVisdiplay: false,
        //     dicData: DIC.DELETE_FLAG
        // },
        {
            label: "备注",
            prop: "remarks",
            type: "textarea",
            hide: true,
            span: 24,
            max: 255
        }
    ]
};